import DraftReportCard from './DraftReportCard';

export default DraftReportCard;
